import { APP_INITIALIZER, Provider, inject } from '@angular/core';

import { AppVersionService } from '../services/app-version.service';

export const providerAppVersionCheck: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: () => {
    const service = inject(AppVersionService);
    return () => service.init();
  }
};
